import React from 'react';
import { get, noop } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DrugPricingDrugSearchService } from 'services/drugPricingDrugSearch';
import { drugPricingDrugSearch as DrugPricingDrugSearchView } from 'ui/views/widgets/drugPricingDrugSearch';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { DrugPricingDrugSearch } from 'ui/containers/DrugPricingDrugSearch';
 *
 * // render
 * <DrugPricingDrugSearch propName='propValue'/>
 */
export class DrugPricingDrugSearch extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        log.debug( 'DrugPricingDrugSearch.constructor()' );

        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.drugPricingDrugSearchService = new DrugPricingDrugSearchService();
        
        // start data fetch
        this.fetchComponentData();

        // bind
        this.__bind();

    }

    /**
     * @desc bind events and methods
     */
    __bind() {
        log.debug( 'DrugPricingDrugSearch.__bind()' );
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'DrugPricingDrugSearch.fetchComponentData()' );

        // cancel ongoing request
        this.drugPricingDrugSearchService.cancel();

        // fetch component data
        const { status, data } = await this.drugPricingDrugSearchService.fetchComponentData( {
            url: this.props.widget.url,
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {

            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                currentStep: data.currentStep
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.drugPricingDrugSearchService.cancel(); // cancel ongoing requests
    }


    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <DrugPricingDrugSearchView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onQueryChange={ this.props.onDrugSearchQueryChange }
                onSelect={ this.props.onDrugSelect }
                requestPayload={ this.props.requestPayload }
            />
        );
    }
}

// set display name
DrugPricingDrugSearch.displayName = 'DrugPricingDrugSearch';

// set default props
DrugPricingDrugSearch.defaultProps = {
    requestPayload: {},
    onDrugSearchQueryChange: noop,
    onDrugSelect: noop,
};

// prop types
DrugPricingDrugSearch.propTypes = {};
